
export default class CalendarEventsManagementService {
  constructor(assignablesExcluded = []) {
    this.startDate = null;
    this.endDate = null;
    this.assignablesExcluded = new Set(assignablesExcluded);
  }

  handleAssignableSelection(assignableId, selected) {
    if (selected) {
      this.assignablesExcluded.delete(assignableId);
    } else {
      this.assignablesExcluded.add(assignableId);
    }

    this.#setQueryParams();
  }

  async fetchEvents(dateRange = {}) {
    const queryParams = this._createEventsRequestQueryParams(dateRange);
    const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute('content');

    try {
      const response = await fetch(`/calendar_events.json?${queryParams.toString()}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        }
      });
  
      const data = await response.json();

      return data;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  /**
   * Helper to create the query params to fetch calendar events
   * Params returned include:
   * start_date: date
   * end_date: date
   * exclude_assignable_ids: string[]
   * @returns URLSearchParams instance
   */
    _createEventsRequestQueryParams(dateRange = {}) {
      const queryParams = new URLSearchParams();

      const startDate = dateRange.startStr;
      const endDate = dateRange.endStr;
      const assignablesExcludedIds = Array.from(this.assignablesExcluded);
  
      if (assignablesExcludedIds.length > 0) {
        queryParams.append('exclude_assignable_ids', assignablesExcludedIds.join(','));
      }
  
      if (startDate && endDate) {
        queryParams.append('start_date', startDate);
        queryParams.append('end_date', endDate);
      }
  
      return queryParams;
    }

  /**
   * Helper to keep query params updated with the corresponding instance variables
   */
  #setQueryParams() {
    const urlParams = new URLSearchParams(window.location.search);

    if (this.startDate) urlParams.set('start_date', this.startDate);
    if (this.endDate) urlParams.set('end_date', this.endDate);

    const assignablesExcludedIds = Array.from(this.assignablesExcluded);
    urlParams.set('exclude_assignable_ids', assignablesExcludedIds.length > 0 ? assignablesExcludedIds.join(',') : '');

    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
  }

  /**
   * @param {*} calendar Full Calendar Intance
   * It syncs given calendar dates with the current event-management instance' dates variables
   */
  syncCalendarDates(calendar) {
    const currentView = calendar.view;
    const newStartDate = currentView.currentStart.toISOString();
    const newEndDate = currentView.currentEnd.toISOString();

    if (newStartDate !== this.startDate || newEndDate !== this.endDate) {
      this.startDate = newStartDate;
      this.endDate = newEndDate;
      this.#setQueryParams();
    }
  }
}
